<template>
  <v-container class="px-0" fluid>
    <v-row>
      <v-col :class="$vuetify.breakpoint.smAndUp ? 'pr-10' : ''" cols="12" sm="9">
        <v-card :class="$vuetify.breakpoint.smAndUp ? 'pa-6' : 'pa-4'">
          <h4 class="mb-6">Das interessiert die anderen</h4>

          <v-list three-line>
            <template v-for="(content, index) in communityTopics">
              <fin-community-content :key="index"
                                     :content="content"
                                     :subtitle="content.title"
                                     class="comm-content-row">
                <template #customContent>
                  <v-icon :color="$finColors.primaryDark">icon-dialog</v-icon>
                  {{ content.replies }}
                </template>
              </fin-community-content>
            </template>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" sm="3">
        <p>Verfolge, was die anderen interessiert, tausche dich aus oder starte eine neue Diskussion.</p>
        <v-btn :to="{name: 'forum_add'}" class="mb-6" outlined>Diskussion starten</v-btn>
        <v-img :max-width="200" :src="require('@/assets/finCommunity/community-people.svg')" contain/>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card class="pa-6">
          <h4 class="mb-6">Top Score</h4>

          <p>Wer hat innerhalb der letzten 30 Tagen die spannendsten Beiträge mit den meisten Likes veröffentlicht?</p>

          <v-list three-line>
            <template v-for="(content, index) in sortByScore">
              <fin-community-content :key="index"
                                     :content="content"
                                     :subtitle="'finScore ' + content.finScore"
                                     hide-category
                                     class="comm-content-row"
                                     hide-time-ago>
                <template #customContent>
                  <v-icon :color="$finColors.primaryDark">icon-dialog</v-icon>
                  <span class="replies ml-2">{{ content.replies }} Beiträge</span>
                </template>
              </fin-community-content>
            </template>
          </v-list>
        </v-card>
      </v-col>
      <v-col>
        <v-card class="pa-6">
          <h4 class="mb-6">Top Performer</h4>

          <p>Lerne von den Besten! Wer hat mit seinem Portfolio in den letzten 4 Wochen die höchste Rendite erzielt?</p>

          <v-list three-line>
            <template v-for="(content, index) in sortByPerformance">
              <fin-community-content :key="index"
                                     :avatar-badge-nr="++index"
                                     :content="content"
                                     :subtitle="content.portfolio.name"
                                     hide-category
                                     class="comm-content-row"
                                     hide-time-ago>
                <template #customContent>
                  <v-icon :color="$finColors.accentGreen">icon-value-up</v-icon>
                  <fin-percentage-change :change="content.portfolio.performance"
                                         style="display: inline;"/>
                </template>
              </fin-community-content>
            </template>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
    import {communityTopics} from '@/mocks/Community'
    import FinCommunityContent from "@/components/common/CommunityContent"
    import FinPercentageChange from "@/components/common/PercentageChange/index"

    export default {
  name: 'fin-community-wrapper',
  components: {
    FinPercentageChange,
    FinCommunityContent,
  },
  data() {
    return {
      showAllText: 'Mehr anzeigen',
      communityTopics
    }
  },
  computed: {
    sortByScore() {
      return [...this.communityTopics].sort((a, b) => b.finScore - a.finScore)
    },
    sortByPerformance() {
      return [...this.communityTopics].sort((a, b) => b.portfolio.performance - a.portfolio.performance)
    }
  }
}
</script>

<style lang="scss" scoped>
.comm-content-row {
  border-bottom: 1px solid $fin-color-light-sky-blue;
  /* decrease vuetify default min-height of v-list-item */
  min-height: 70px;
}

.comm-content-row:last-child {
  border-bottom: none;
}

.replies {
  font-family: $body-font-family;
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  color: $fin-color-primary-dark;
}

h4 {
  font-family: $body-font-family;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.1;
  letter-spacing: normal;
  color: $fin-color-primary-dark;
}
</style>
